// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3egw1","noInteraction":"EventWrapper_noInteraction__3pmaD","pointerPassthrough":"EventWrapper_pointerPassthrough__3Of4w"};